var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"headers"},[_c('img',{staticClass:"headerimg",attrs:{"src":_vm.header_cover,"alt":""}}),_c('div',{staticStyle:{"width":"100%","MARGIN":"0 auto","position":"fixed","top":"20px"}},[_c('el-alert',{attrs:{"title":"非正式上线页面,仅供内部预览参考","type":"warning","show-icon":"","center":"","closable":false}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }